<!-- =========================================================================================
    File Name: MSMessageBox.vue
    Description: Component MsMessageBox - Component hiện thị thông báo
    ----------------------------------------------------------------------------------------
    Author: nntam - 15/8/2019
========================================================================================== -->
<template>
	<div id="message-box">
		<!-- <div id="message-box" > -->
		<div class="con-ms-message-box" v-if="isShowMessage">
			<div class="message-center">
				<div class="ms-message-bg"></div>
				<div class="ms-mesage-box">
					<div
						class="close-button"
						v-tooltip="$t('i18nCommon.Close')"
						v-if="option.close"
						@click="btnCloseClick"
					></div>
					<div :style="[{ width: option.width, minWidth: '400px' }]">
						<div
							class="ms-pdt-15px"
							:class="[
								option.classContent ? option.classContent : '',
								option.noClassPaddingBottom ? 'pb-0' : 'ms-pdb-24px',
							]"
						>
							<!-- 'align-items-center': (!showMessageDetail && option.title ==null) -->
							<div
								class="ms-header-message flex"
								:class="
									option.hiddenBorderHeader ? 'ms-header-message-nborder' : ''
								"
							>
								<div class="title" v-if="option.title != null">
									{{ option.title }}
								</div>
								<div v-if="option.isClose" @click="btnCloseClick">
									<div class="mi-new-v2 mi-20 mi-close-popup-v2 pointer"></div>
								</div>
							</div>
							<div
								:class="{ content: true }"
								class="ms-pdl-20px ms-pdr-20px ms-content-message"
								:style="{
									'justify-content': option.textAlignMessage
										? option.textAlignMessage
										: '',
								}"
							>
								<!-- <div class="icon-message" v-if="option.icon">
                  <div class="mi mi-55" :class="[option.icon]"></div>
								</div>-->
								<div
									class="message-content flex items-center"
									:style="getStyle"
									:class="[
										option.classMessageContent
											? option.classMessageContent
											: '',
									]"
								>
									<span
										id="idMessage"
										class="message font-size-content"
										:class="[
											option.maxHeightMessage ? option.maxHeightMessage : '',
										]"
										v-if="option.message"
										v-html="message"
									></span>
									<div
										class="mess-link"
										v-if="
											option.messageDetail !== '' &&
											option.messageDetail != null &&
											!showMessageDetail
										"
										@click="showMessageDetail = true"
									>
										<div class="mi mi-14 mi-chevron-down--primary-small"></div>
										<div>{{ $t('i18nCommon.ExpandTooltip') }}</div>
									</div>
									<span v-if="option.messageDetail !== '' && showMessageDetail">
										&nbsp;{{ option.messageDetail }}
										<div
											class="mess-link"
											v-if="
												option.messageDetail !== '' &&
												option.messageDetail != null &&
												showMessageDetail
											"
											@click="showMessageDetail = false"
										>
											<div class="mi mi-14 mi-chevron-up--primary-small"></div>
											<div>{{ $t('i18nCommon.CollapseTooltip') }}</div>
										</div>
									</span>
									<!-- Sử dụng component được truyền vào -->
									<component
										v-if="option.optionsCustom && option.optionsCustom.template"
										:is="option.optionsCustom.template"
										v-bind="option.optionsCustom.props"
										v-on="option.optionsCustom.templateEvent"
									></component>
								</div>
							</div>
							<!-- <div class="mess-line" v-if="option.line"></div> -->
							<div
								class="mess-footer ms-pdl-20px ms-pdr-20px"
								v-on:keydown="footerKeydown"
								v-if="showButton"
							>
								<!-- nntam - 16/04/2020 thêm computed để bog v-if lồng v-for -->
								<div
									:class="[button.target]"
									v-for="button in listBtn"
									:key="button.key"
								>
									<ms-button
										class="min-width-btn"
										@keydown="escAction"
										:type="button.typeButton"
										:ref="button.focus ? 'btnFocus' : 'btnOther'"
										@click="btnClick(button)"
										:title="button.text"
										:icon="button.icon"
									></ms-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import commonFunc from '@/common/commonFunction';
export default {
	name: 'MsMessageBox',
	props: {
		// chiều rộng của messagebox
		width: {
			type: String,
			default: '400px',
		},
		// option cấu hình messageBox
		option: {
			type: Object,
			default: null,
		},
	},
	computed: {
		listBtn() {
			return this.option.btnConfig.filter((x) => x.hasBtn == true);
		},
		getStyle() {
			const me = this;
			if (!me.option || !me.option.maxHeight) {
				return {};
			}
			return { 'max-height': me.option.maxHeight + 'px !important' };
		},
	},
	data() {
		let showButton = false;
		for (let i = 0; i < this.option.btnConfig.length; i++) {
			if (this.option.btnConfig[i].hasBtn) {
				showButton = true;
				break;
			}
		}

		return {
			isShowMessage: true,
			showMessageDetail: false,
			message: '',
			showButton: showButton,
		};
	},
	methods: {
		/**
		 * Bắt sự kiện click vào button
		 */
		btnClick(button) {
			let key = button.key;
			if (key != 'PermissionGuild') {
				this.isShowMessage = false;
			}
			if (button.callback) {
				button.callback();
			} else {
				this.$emit('btnClick', this, key);
			}
		},
		escapeContent(htmlContent) {
			//Thay đổi toàn bộ kí tự đặc biệt `<`, `>` sang ký hiệu tương ứng để không bị ảnh hưởng việc hiển thị html
			return htmlContent.replace(/>/g, '&gt;').replace(/</g, '&lt;');
		},
		escAction(e) {},
		footerKeydown(e) {
			const me = this;
			commonFunc.processUnfocusLastControl(e, function () {
				commonFunc.focusFirstControl(me.$el);
			});
		},
		linkActive_OnClick() {
			this.$emit('linkActive');
			if (this.option.closeMessageAfterLink) {
				this.isShowMessage = false;
			}
		},
		linkPopup_OnClick() {
			this.$emit('linkPopup');
			this.isShowMessage = false;
		},
		btnCloseClick() {
			const me = this;
			me.isShowMessage = false;
			me.$emit('btnCloseClick');
		},
	},
	mounted() {
		//Focus — không focus vào button nào để tránh thay đổi trạng thái mặc định

		// hiện thị text ra message box
		let tt = document.getElementById('idMessage');
		if (this.option.message != '' && tt != null) {
			// nếu truyền thml thì vẫn để thế còn truyền text thì chuyển lại thành ký từ đặc biệt để nó không bị biến thành html khi hiển thị
			if (
				/<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(
					this.option.message
				)
			) {
				tt.innerHTML = this.option.message;
			} else {
				this.message = this.option.message;
			}
		}

		let linkActive = this.$el.querySelector('.link-active'),
			linkPopup = this.$el.querySelector('.link-open-popup');

		if (linkActive !== null) {
			linkActive.addEventListener('click', this.linkActive_OnClick);
		}
		if (linkPopup !== null) {
			linkPopup.addEventListener('click', this.linkPopup_OnClick);
		}
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msMessageBox.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msMessageBox.scss';
}
.ms-header-message {
	padding-top: 10px;
	padding-left: 20px;
	padding-right: 20px;
	justify-content: space-between;
}
.ms-header-message-nborder {
	border-bottom: none;
}
.ms-content-message {
	font-size: 13px;
	color: $ms-color-neutral-1000;
}
.font-size-content {
	font-size: 13px;
}

.ms-pdb-24px {
	padding-bottom: 24px;
}

/deep/.message {
	ol {
		list-style-type: decimal;
		padding-left: 20px;
	}
	ul {
		list-style-type: disc;
		padding-left: 20px;
	}
}
</style>
